// Slovenské dvojče locale/cs/serviceModal.js.
export default {
  title: 'Záručný a pozáručný servis',
  sub: 'Servisné stredisko Jipos · predajňa Bílina',
  close: 'Zavrieť',
  done: 'Rozumiem',
  page: 'Všetko o servise',
  loading: 'Načítavame informácie o servise…',
  error: 'Informácie o servise sa teraz nepodarilo načítať.',
  services: 'Čo ponúkame',
  pricing: 'Orientačný cenník',
  why: 'Prečo servis u nás',
  freeRe: /zadarmo|zdarma/i,
};
